
export const constants = {
   apiServer: 'https://tumenu.online/api',
   pathImagesIntro: 'https://tumenu.online/images/intros',
   pathImagesMenu: 'https://tumenu.online/images/menus',  
   pathImagesTags: 'https://tumenu.online/images/tags',
   pathIconCategories: 'https://tumenu.online/images/categories/icons',  
   pathLogoRestaurant: 'https://tumenu.online/images/restaurants/logos',  
   
}